import PropTypes from 'prop-types';
import React from 'react';
import { Tooltip, ButtonCircle, Text } from 'rebass';

const InfoTooltip = ({ children }) => (
  <Tooltip
    title={children}
    style={{
      zIndex: 10,
    }}
  >
    <ButtonCircle
      size={18}
      style={{
        minHeight: '18px',
        lineHeight: '18px',
      }}
    >
      <Text small>?</Text>
    </ButtonCircle>
  </Tooltip>
);

InfoTooltip.propTypes = {
  children: PropTypes.node.isRequired,
};

export default InfoTooltip;
